import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import { IconButton, Tooltip } from '@mui/material'
import {
  GenericOrderBy,
  GenericTable,
  TableHeaderConfig,
  getNewDirection
} from '../../components/_EOS/Table'
import { Modal } from '../../components/_EOS/Modal'
import { useModal } from '../../hooks/useModal'
import { ReturnsCreateReturn } from '../../components/Returns/ReturnsCreateReturn'
import { useSnackbar } from '../../hooks/useSnackbar'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { useApi } from '../../hooks/useApi'
import { ApiResponse } from '../../typings/ApiResponse'
import { Asn } from '../../interfaces/Asn/Asn'
import { ApiConfig, apiCall } from '../../config/api'
import DeleteIcon from '@mui/icons-material/Delete'
import VisibilityIcon from '@mui/icons-material/Visibility'
import AssignmentIcon from '@mui/icons-material/Assignment'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { AsnBlog } from '../../components'
import { AsnViewer } from '../../components/ASN/AsnViewer/AsnViewer'
import { ConfirmAction } from '../../components/ConfirmAction'
import { eAsnState } from '../../enums/eAsnState'
import { usePagination } from '../../hooks/usePagination'
import { eTypeReturnModal } from './types'
import { Status } from '../../hooks/useFetchState'
import { useUser } from '../../hooks/useUser'
import { utcToLocal } from '../../utils/dateHelper'
import { deleteAsn } from '../PackingList/packingListActionPage'
import { AjustReturnSearch } from '../../components/Returns/adjustReturn/AdjustReturnSearch'
import { Filter } from '../../components/_WMS/FilterComponent'
import { getReturnAsn, putReceiveASN } from './config/api'

type CustomActionsProps = {
  id: number
}

interface ReturnsPageProps {}

// Configuration for the headers of the ReturnsTable
const headersConfig: TableHeaderConfig[] = [
  { field: 'asnId', title: 'ID', sortable: true },
  { field: 'asnNumber', title: 'Nro ASN', sortable: true },
  {
    field: 'createdDate',
    title: 'Fecha creación',
    sortable: true,
    formater: (value) => utcToLocal(value, 'dd/MM/yyyy')
  },
  { field: 'asnStateName', title: 'Estado', sortable: true },
  { field: 'supplierName', title: 'Razón Social', sortable: true },
  { field: 'typeAsnIncomeName', title: 'Tipo Ingreso' },
  { field: 'externalOrderId', title: 'ID de Pedido', sortable: true }
]

export const ReturnsPage: React.FC<ReturnsPageProps> = () => {
  const [selectedFilters, setSelectedFilters] = React.useState<Filter[]>([])
  const [element, setElement] = useState<Asn | undefined>(undefined)
  const [type, setType] = useState<eTypeReturnModal | undefined>(undefined)
  const { isActive, message, isSuccess, openSnackBar } = useSnackbar()
  const [titleModalBlog, setTitleModalBlog] = useState<string | undefined>('')
  const [loadDelete, setLoadDelete] = useState<boolean>(false)

  const [orderBy, setOrderBy] = useState<GenericOrderBy<Asn>>({
    field: 'asnId',
    direction: 'desc'
  })

  const pagination = usePagination(5)

  const { size, isOpen, openModal, closeModal } = useModal('Nueva Inversav2')

  const {
    size: blogModalSize,
    isOpen: blogModalIsOpen,
    openModal: blogModalOpenModal,
    closeModal: blogModalCloseModal
  } = useModal('')

  const {
    size: viewModalSize,
    isOpen: viewModalIsOpen,
    title: viewModalTitle,
    openModal: viewModalHandleOpen,
    closeModal: viewModalHandleClose
  } = useModal('Detalle de ASN de devolución')

  const {
    userDataState: { userData }
  } = useUser()

  const { state, callApi } = useApi<ApiResponse<Asn>>()

  const requestReturnAsn = (
    filters?: Filter[],
    orderBy?: GenericOrderBy<Asn>,
    page?: number,
    pageSize?: number
  ) => {
    callApi(getReturnAsn(filters, orderBy, page, pageSize))
  }

  useEffect(() => {
    requestReturnAsn(selectedFilters, orderBy, undefined, undefined)
  }, [orderBy])

  const { state: stateReceiveASN, callApi: callApiReceiveASN } = useApi()

  const receiveASN = (asnId: number, closeModal: () => void) => {
    callApiReceiveASN(putReceiveASN(asnId, userData?.userId))
      .then((response) =>
        openSnackBar(
          `ASN ${response.asnNumber} recepcionada correctamente`,
          true
        )
      )
      .catch((error) =>
        openSnackBar(
          error.response?.data?.message ||
            `Ocurrió un error al recepcionar ASN ${asnId}`,
          false
        )
      )
      .finally(closeModal)
  }

  const handleShowModalBlog = (id: number) => {
    setTitleModalBlog('Bitácora')
    blogModalOpenModal('md')
    const element = getRowDataFromId(id)
    setType(1)
    setElement(element)
  }

  const handleCloseModalAsnReturn = () => {
    closeModal()
    pagination.setPagination(0, pagination.pageSize)
    requestReturnAsn(
      selectedFilters,
      orderBy,
      pagination.page,
      pagination.pageSize
    )
  }

  const handleShowAsnViewer = (id: number) => {
    const element = getRowDataFromId(id)
    setElement(element)
    viewModalHandleOpen('lg')
  }

  const handleshowReceivedComponent = (id: number) => {
    setTitleModalBlog('Recepción')
    blogModalOpenModal('sm')
    const element = getRowDataFromId(id)
    setType(3)
    setElement(element)
  }

  const handleshowDeleteComponent = (id: number) => {
    setTitleModalBlog('Confirmar')
    blogModalOpenModal('sm')
    const element = getRowDataFromId(id)
    setType(4)
    setElement(element)
  }

  const handleDeleteCancel = (asnId: number, asnNumber: string) => {
    const estateASN = state.data?.items.filter((el) => el.asnId === asnId)[0]
      .asnStateId

    if (eAsnState.Pending === estateASN) {
      handleDeleteAsn(asnId, asnNumber)
    }

    if (eAsnState.Received === estateASN) {
      handleAnulationAsn(asnId, asnNumber)
    }
  }

  const handleDeleteAsn = (asnId: number, asnNumber: string) => {
    const estateASN = state.data?.items.filter((el) => el.asnId === asnId)[0]
      .asnStateId

    if (eAsnState.Pending === estateASN) {
      setLoadDelete(true)
      setTimeout(() => {
        deleteAsn(asnId)
          .then((response) => {
            if (response === 200 || response === 201 || response === 204) {
              // handleGetPackingList(supplierId)
              openSnackBar(`Se ha eliminado el ASN N° ${asnNumber}`, true)
            } else {
              openSnackBar(
                `Ha ocurrido un error al eliminar ASN N° ${asnNumber}`,
                true
              )
            }

            requestReturnAsn(selectedFilters, orderBy, undefined, undefined)
          })
          .catch(() => {
            openSnackBar(
              `Ha ocurrido un error al eliminar ASN N° ${asnNumber}`,
              true
            )
          })
        setLoadDelete(false)
        blogModalCloseModal()
      }, 1500)
    }
  }

  const handleAnulationAsn = (asnId: number, asnNumber: string) => {
    setLoadDelete(true)
    apiCall('PUT', ApiConfig.AsnApi + `/CancelAsnAsync/${asnId}`)
      .then((response) => {
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          openSnackBar(`Se ha anulado ASN N° ${asnNumber}`, true)
        } else {
          openSnackBar(
            `Ha ocurrido un error al anular ASN N° ${asnNumber}`,
            true
          )
        }
      })
      .catch((error: any) =>
        openSnackBar(
          `Ha ocurrido un error al Anular ASN N° ${asnNumber} - ${error}`,
          false
        )
      )
      .finally(() => {
        setLoadDelete(false)
        blogModalCloseModal()
        requestReturnAsn(selectedFilters, orderBy, 0, pagination.pageSize)
      })
  }

  const renderModal = (element: Asn, typeModal: eTypeReturnModal) => {
    switch (typeModal) {
      case eTypeReturnModal.ASN_BLOG_MODAL:
        return <AsnBlog asnId={element.asnId} asnNumber={element.asnNumber} />
      case eTypeReturnModal.ASN_VIEW_MODAL:
        return <AsnViewer element={element} />
      case eTypeReturnModal.ASN_RECEIVE_MODAL:
        return (
          <ConfirmAction
            handleCloseModal={blogModalCloseModal}
            handleSubmitAction={() => {
              receiveASN(element.asnId, () => {
                blogModalCloseModal()
                requestReturnAsn(
                  selectedFilters,
                  orderBy,
                  pagination.page,
                  pagination.pageSize
                )
              })
            }}
            confirmTitle={`¿Esta seguro que desea recepcionar ASN N° ${element.asnNumber}?`}
            confirmText='Confirmar'
            negateText='Cancelar'
            isLoading={stateReceiveASN.status === Status.Loading}
          />
        )
      case eTypeReturnModal.ASN_DELETE_MODAL:
        return (
          <ConfirmAction
            handleCloseModal={closeModal}
            handleSubmitAction={() =>
              handleDeleteCancel(element.asnId, element.asnNumber)
            }
            confirmTitle={`¿Esta seguro que desea ${
              element.asnStateId === eAsnState.Received ? 'anular' : 'eliminar'
            } la ASN N° ${element.asnNumber}?`}
            confirmText={
              element.asnStateId === eAsnState.Received ? 'Anular' : 'Eliminar'
            }
            negateText='Cancelar'
            isLoading={loadDelete}
          />
        )
    }

    return undefined
  }

  const MyCustomActions: React.FC<CustomActionsProps> = ({ id }) => {
    return (
      <Fragment>
        <Tooltip title='Ver Bitácora' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() => handleShowModalBlog(id)}
            style={{ verticalAlign: 'bottom' }}
          >
            <AssignmentIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title='ver Asn' aria-label='edit'>
          <IconButton
            aria-label='seeBinacle'
            onClick={() => {
              handleShowAsnViewer(id)
            }}
            style={{ verticalAlign: 'bottom' }}
            disabled={false}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title='Recepcionar' aria-label='edit'>
          <span>
            <IconButton
              aria-label='seeBinacle'
              onClick={() => handleshowReceivedComponent(id)}
              style={{ verticalAlign: 'bottom' }}
              disabled={
                eAsnState.Pending !==
                state.data?.items.filter((el) => el.asnId === id)[0].asnStateId
              }
            >
              <CheckCircleIcon />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title='Anular' aria-label='delete'>
          <span>
            <IconButton
              aria-label='delete'
              onClick={() => handleshowDeleteComponent(id)}
              disabled={
                eAsnState.Pending !==
                  state.data?.items.filter((el) => el.asnId === id)[0]
                    .asnStateId &&
                eAsnState.Received !==
                  state.data?.items.filter((el) => el.asnId === id)[0]
                    .asnStateId
              }
            >
              <DeleteIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Fragment>
    )
  }

  const getRowDataFromId = (id: number) => {
    return state.data?.items.filter((element) => element.asnId === id)[0]
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    if (pageSize !== pagination.pageSize) {
      page = 0 // 'cambio número páginas'
    }

    pagination.setPagination(page, pageSize)
    requestReturnAsn(selectedFilters, orderBy, page, pageSize)
  }

  const handleSorting = ({ field, direction }: GenericOrderBy<Asn>) => {
    if (field === orderBy.field) {
      const newDirection = getNewDirection(orderBy.direction)
      setOrderBy((prev) => ({ ...prev, direction: newDirection }))
      return
    }

    setOrderBy({ field, direction })
  }

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)
    requestReturnAsn(
      selectedFilters,
      orderBy,
      pagination.page,
      pagination.pageSize
    )
  }, [orderBy, selectedFilters])

  return (
    <Fragment>
      <StandardPage
        pageTitle='Devoluciones'
        buttonAction={() => openModal('xl')}
        buttonTitle='Nueva Devolución'
      >
        <AjustReturnSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={requestReturnAsn}
          defaultSelectedFilterKey='trackingNumber'
        />

        <GenericTable<Asn>
          data={state.data?.items}
          headersConfig={headersConfig}
          IDKey='asnId'
          customActionComponent={MyCustomActions}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
          onSortChange={handleSorting}
          orderField={orderBy}
        />
      </StandardPage>

      <Modal
        open={isOpen}
        title={titleModalBlog}
        onClose={handleCloseModalAsnReturn}
        maxWidth={size}
      >
        <ReturnsCreateReturn
          onSearch={() => {}}
          handleSnackbar={openSnackBar}
          handleModal={() => {
            handleCloseModalAsnReturn()
          }}
          setTitleModalBlog={setTitleModalBlog}
        />
      </Modal>
      <Modal
        open={blogModalIsOpen}
        title={titleModalBlog}
        onClose={blogModalCloseModal}
        maxWidth={blogModalSize}
      >
        {blogModalIsOpen && renderModal(element!, type!)}
      </Modal>
      <Modal
        open={viewModalIsOpen}
        title={viewModalTitle}
        onClose={viewModalHandleClose}
        maxWidth={viewModalSize}
      >
        <AsnViewer element={element!} hideInfoReturnAsn={true} />
      </Modal>
      <SnackBar
        message={message}
        status={isSuccess ? 'success' : 'error'}
        open={isActive}
      />
    </Fragment>
  )
}
